import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import { AppStore } from '../store';
import { refreshToken } from './api/authService';
import { removeToken } from './storageService';
import errorInterceptor from './interceptors/errorInterceptor';
import { setUserToken } from '../store/authSlice';

const defaultAxiosOptions = {
   baseURL: process.env.REACT_APP_VIRTUAL_FOLDER,
};

let appStore: AppStore;

export interface ApiResponse<T> {
  items: T[];
  totalCount: number;
  currentCount: number;
}

export function setStore(store: AppStore): void {
  appStore = store;
}

export function getToken(): string | null {
  return appStore.getState().auth.token;
}

export function getUserId(): string | undefined {
  return appStore.getState().auth.userDetails?.nameid;
}

const authorizationInterceptor = (config: AxiosRequestConfig) => {
  const token = getToken();

  if (token) {
    const authHeader = { Authorization: 'Bearer ' + token };

    if (config.headers) {
      config.headers = {
        ...config.headers,
        ...authHeader,
      };
    } else {
      config.headers = {
        ...authHeader,
      };
    }
  }

  return config;
};

const refreshTokenInterceptor = (error: AxiosError) => {
  const originalConfig = error.config;
  const oldToken = getToken();

  if (
    !(originalConfig.url == '/api/Auth' && originalConfig.method == 'post') &&
    error.response &&
    oldToken
  ) {
    if (error.response.status === 0) {
      refreshToken(oldToken)
        .then((resp) => {
          appStore.dispatch(setUserToken(resp));

          console.log('hit');
          console.log(resp);
        })
        .catch((_error) => {
          removeToken();

          console.log(_error);
          console.log('hit error');

          return Promise.reject(_error);
        });
    }
  }

  return Promise.reject(error);
};

class HttpService {
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create(defaultAxiosOptions);

    this.axiosInstance.interceptors.request.use(authorizationInterceptor);
   
    this.axiosInstance.interceptors.response.use(
      (response) => response,
      errorInterceptor
    );
  }

  get axios() {
    return this.axiosInstance;
  }

  get<D = unknown>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<D>> {
    return this.axiosInstance.get(url, {
      ...config,
    });
  }

  post<T, D = unknown>(
    url: string,
    data?: T,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<D>> {
    return this.axiosInstance.post(url, data, { ...config });
  }

  put<T, D = unknown>(
    url: string,
    data?: T,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<D>> {
    return this.axiosInstance.put(url, data, { ...config });
  }

  delete<T, D = unknown>(
    url: string,
    data?: T,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<D>> {
    return this.axiosInstance.delete(url, { data: data, ...config });
  }
}

export const httpService = new HttpService();
